<div *ngIf="!documentSigned" class="container">
  <div class="signature-container">
    <button class="close-button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="info-text" *ngIf="receivedAliasLoader && !openDesktopAppAdvise">
      <span>{{openDesktopApp}}</span>
    </div>
    <div class="info-text-warning" *ngIf="receivedAliasLoader && openDesktopAppAdvise">
      <span>{{desktopAppWarning}}</span>
    </div>
    <div class="action-row-first" *ngIf="!receivedAliases">
      <div class="document-info">
        <span class="label">{{document}}</span>
        <span class="document-name">{{fileName}}</span>
        <mat-icon matTooltip="{{saveDocument}}" (click)="downloadDocument()">download</mat-icon>
      </div>
      <button *ngIf="!receivedAliasLoader" mat-raised-button color="primary"
              (click)="initializeSignature()">{{beginSigning}}
      </button>
      <mat-spinner *ngIf="receivedAliasLoader" [diameter]="35" class="loading-spinner"></mat-spinner>
    </div>
    <div class="close-button-container" *ngIf="!receivedAliases && !receivedAliasLoader">
      <button mat-raised-button color="primary" (click)="closeDialog()">Alege un alt loc pentru semnatura</button>
    </div>
    <div class="center-container" *ngIf="receivedAliases" style="margin-top: 30px">
      <mat-form-field appearance="fill">
        <mat-label>{{selectCertificate}}</mat-label>
        <mat-select [(value)]="selectedAlias">
          <mat-option *ngFor="let alias of aliases" [value]="alias">{{ alias }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="selectedAlias" style="margin-left: 2rem">
        <mat-label>{{insertPassword}}</mat-label>
        <input matInput [(ngModel)]="password" type="password">
      </mat-form-field>

      <div class="action-row">
        <button *ngIf="!isLoading" mat-raised-button color="primary" (click)="signDocument()" [disabled]="!password">
          {{signDocumentMessage}}
        </button>
        <mat-spinner *ngIf="isLoading" [diameter]="35" class="loading-spinner" style="margin-left: 4rem"></mat-spinner>
      </div>

    </div>
  </div>
</div>

